import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { RequiredFieldAstrick } from "components/Common/Common";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { useCreateConsentCheckListsMutation, useUpdateConsentCheckListsMutation } from "store/services/guardian";
import { successMessageToast } from "helpers/common";
import AppInputField from "components/shared/FormComponents/AppInputField";

const AddChecklistPop = ({ show, setShow, clientId, clientType }) => {

    const { id, parentId } = useParams()
    const [initialValues, setInitialValues] = useState({ receipt: "" })
    const [createTerm, { isLoading: createTermLoading }] = useCreateConsentCheckListsMutation();
    const [updateTerm, { isLoading: updateTermLoading }] = useUpdateConsentCheckListsMutation();
    const editMode = false

    const handleSubmit = async (values) => {

        const body = {
            client_id: id,
            title: values?.title,
            parent_id: parentId,
            status: "unchecked"
        }
        try {
            const result = editMode ? await updateTerm({ data: body }) : await createTerm(body);
            if (result?.error) return;

            successMessageToast(result?.data?.message);
            handlePopup()
        } catch (err) {
            console.error("Error creating mdt term", err);
        }
    };

    const handlePopup = () => setShow(false)


    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div onClick={handlePopup} style={{ display: "inline-block" }}>
                        <Button
                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue">Assign Checklist</h6>
                    </div>
                    <section
                        className={`${styles.ClientDetail} position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row>
                                <Col
                                    lg="12"
                                    className=""
                                >
                                    <Row>
                                        <Col lg="12" className="my-3">
                                            <Formik
                                                initialValues={initialValues}
                                                // validationSchema={appointmentsValidationSchema}
                                                onSubmit={handleSubmit}
                                                enableReinitialize
                                            >
                                                {({
                                                    handleSubmit, values, setFieldValue, errors
                                                }) => (
                                                    <Form onSubmit={handleSubmit}>
                                                        <div
                                                            className="py-3"
                                                        //   style={{ borderTop: "1px solid #41a2a84d" }}
                                                        >
                                                            <Row>
                                                                {
                                                                    <Col md="12" sm="6" className="my-2">
                                                                        <label
                                                                            htmlFor=""
                                                                            className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                        >
                                                                            Title
                                                                            <RequiredFieldAstrick />
                                                                        </label>
                                                                        <AppInputField
                                                                            type="text"
                                                                            name="title"
                                                                            placeholder="Enter Checklist Title"
                                                                            className={`${styles.formControl} form-control`}
                                                                            maxLength={50}
                                                                        />
                                                                    </Col>
                                                                }


                                                            </Row>
                                                        </div>
                                                        <Row className="mt-4">
                                                            <Col className="my-2" lg="12">
                                                                <div
                                                                    className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                                    style={{ borderTop: "1px solid #41a2a84d" }}
                                                                >
                                                                    <Button type="submit" disabled={createTermLoading} className="d-flex align-items-center justify-content-center commonBtn">
                                                                        {createTermLoading ? <LoadingIndicator inline /> : "Save"}

                                                                    </Button>
                                                                    {/* <Button
                                                                          type="button"
                                                                          className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                                                                          onClick={() => navigate(MANAGE_PARENTS_LIST)}
                                                                        >
                                                                          Cancel
                                                                        </Button> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </section>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default AddChecklistPop;